import React from "react";
import Button from "../../components/Button";
import PartPreview from "../../components/PartPreview";
import { deletePart, getMyParts } from "../../util/parts";
import "./Home.css";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      parts: [],
    };
  }

  componentDidMount() {
    getMyParts().then(parts => this.setState({ parts, loaded: true }));
  }

  render() {
    const { loaded, parts } = this.state;
    const hasParts = !loaded || parts.length > 0;
    return (
      <div>
        <div className="partList">
          <div className="partBanner">
            <h1>Your Parts</h1>
            <Button linkPath="/part/new">New Part</Button>
          </div>
          {hasParts ? (
            parts.map(part => (
              <PartPreview
                key={part.createdAt}
                name={part.name}
                createdBy={part.createdBy}
                sequence={part.sequence}
                deletePart={(createdBy, name) =>
                  deletePart(createdBy, name).then(
                    this.setState({
                      parts: parts.filter(
                        somePart => somePart.name !== part.name,
                      ),
                    }),
                  )
                }
              />
            ))
          ) : (
            <h3>
              No parts yet. Make one by clicking <code>New Part</code>.
            </h3>
          )}
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js